import { type FC } from "react"

import { exhaustiveGuard } from "@forento/shared/utilities/switch"

import { useDownloadables } from "~/api/downloadable"
import Card, { Cards } from "~/themes/original/components/Card"
import Layout from "~/themes/original/components/Layout"
import PartialLoadingPage from "~/themes/original/components/PartialLoadingPage"
import routes from "~/utilities/routes"

const DownloadablesPage: FC = () => {
	const downloadables = useDownloadables()

	return (
		<Layout>
			{downloadables.status === "error" ? (
				<p>Failed to load downloadables.</p>
			) : downloadables.status === "loading" ? (
				<PartialLoadingPage />
			) : downloadables.status === "success" ? (
				<Cards>
					{downloadables.data.map(downloadable => (
						<Card
							key={downloadable.id}
							title={downloadable.title}
							description={downloadable.shortDescription ?? undefined}
							thumbnailFilePath={downloadable.thumbnailFilePath}
							sticker={{ text: downloadable.priceLabel.value, color: downloadable.priceLabel.color }}
							onClick={routes.downloadable.detail(downloadable.id)}
						/>
					))}
				</Cards>
			) : (
				exhaustiveGuard(downloadables.status)
			)}
		</Layout>
	)
}

export default DownloadablesPage
